const LineDivider = () => {
	return (
		<>
			<div className='flex items-center my-4'>
				<hr className='theme-color border-theme sm:h-1 sm:w-full' />
			</div>
			<div className='inline-block w-1 self-stretch bg-theme mx-6' />
		</>
	);
};

export default LineDivider;
